export default {"src":"/_next/static/media/icon-flag-thailand.c97093c3.svg","height":27,"width":40,"blurWidth":0,"blurHeight":0};